import $ from "jquery";

$(document).ready(function () {
  $(".js-toggle-my-account-box").click(function () {
    $(this).toggleClass("active");
    $(this).next(".js-my-account-box__content").slideToggle();
    return false;
  });
});
